import { useSelector } from "react-redux";
import { useTheme } from "react-jss";
import Button from "../shared/Button";
import useTranslatable from "../../hooks/useTranslatable";
import { ThemeModel } from "../../models/ThemeModel";
import { StoreState } from "../../models/states/StoreState";
import type { Theme } from "../../types/Theme";
import { shouldUseModernTheme } from "../../theme/navigationButtonThemeColors";
import { openViewResponsesWindow } from "../../utils/viewResponsesNavigation";

interface Props {
    surveyTheme: ThemeModel;
    className?: string;
    size?: "small" | "large" | "full" | "flex" | number;
}

export default function ViewResponsesButton(props: Props) {
    const { surveyTheme, className = "navigation__view-responses", size = "large" } = props;
    const theme = useTheme() as Theme;
    const language = useSelector((state: StoreState) => state.interview.language);
    const text = useTranslatable(surveyTheme, "PrintResponsesButton");
    const useModernTheme = shouldUseModernTheme(theme);

    return (
        <Button
            className={className}
            text={text}
            onClick={() => openViewResponsesWindow(language)}
            size={size}
            buttonType="VIEW_RESPONSES"
            outlineAccent={useModernTheme ? "neutral" : undefined}
        />
    );
}
